var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDialogNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5723 38C78.5978 38 80.4785 39.1607 81.4912 40.9018L112.74 94.2946C113.753 96.1808 113.753 98.3571 112.74 100.098C111.728 101.984 109.847 103 107.822 103H45.3231C43.153 103 41.2722 101.984 40.2595 100.098C39.2468 98.3571 39.2468 96.1808 40.2595 94.2946L71.5088 40.9018C72.5215 39.1607 74.4022 38 76.5723 38ZM76.5723 56.5714C74.5469 56.5714 73.1002 58.1674 73.1002 60.0536V76.3036C73.1002 78.3348 74.5469 79.7857 76.5723 79.7857C78.4531 79.7857 80.0445 78.3348 80.0445 76.3036V60.0536C80.0445 58.1674 78.4531 56.5714 76.5723 56.5714ZM81.2019 89.0714C81.2019 86.6049 79.0318 84.4286 76.5723 84.4286C73.9682 84.4286 71.9428 86.6049 71.9428 89.0714C71.9428 91.683 73.9682 93.7143 76.5723 93.7143C79.0318 93.7143 81.2019 91.683 81.2019 89.0714Z",
    fill: "url(#paint0_linear_8065_256586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8065_256586",
    x1: 76.5,
    y1: 38,
    x2: 76.5,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogNotice);
export default __webpack_public_path__ + "static/media/img_dialog_notice.fc2d178204b5223e1189bbeecc87d776.svg";
export { ForwardRef as ReactComponent };